module.exports = __webpack_public_path__ + "img/about.dc19a64a.jpg";